module.exports = __webpack_public_path__ + "img/5clubs.c79f00fa.jpg";